var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"layer"}},[(_vm.exchangeLayerUrl)?_c('div',{staticClass:"exchange_layer"},[_c('div',{staticClass:"layer_deco"},[_c('div',{staticClass:"layer"},[_c('iframe',{ref:"iframe",attrs:{"id":"exchangeLayer","name":"exchangeLayer","src":_vm.exchangeLayerUrl,"title":"포인트 전환 신청 레이어"}})])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }